import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEditorValueEmpty from '../utils/isEditorValueEmpty';
import isOnLastBlock from './utils/isOnLastBlock';
import ensureLastLine from './utils/ensureLastLine';

var LastLine = function LastLine(_ref) {
  var editor = _ref.editor,
      minHeight = _ref.bottomSpace;
  var onMouseDown = React.useCallback(function (event) {
    event.preventDefault();
    ensureLastLine(editor);
  }, [editor]);
  return React.createElement("div", {
    className: "editor-bottom-space",
    style: {
      minHeight: minHeight,
      userSelect: 'none'
    },
    onMouseDown: onMouseDown
  });
};

function LastLinePlugin() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$bottomSpace = _ref2.bottomSpace,
      bottomSpace = _ref2$bottomSpace === void 0 ? 0 : _ref2$bottomSpace;

  function renderEditor(_, editor, next) {
    var children = next();
    return React.createElement(Fragment, null, children, !isEditorValueEmpty(editor.value) && React.createElement(LastLine, {
      editor: editor,
      bottomSpace: bottomSpace
    }));
  }

  renderEditor.propTypes = {
    children: PropTypes.node.isRequired
  };
  return [{
    onKeyDown: function onKeyDown(event, editor, next) {
      if (editor.value.selection.isUnset) return next();

      if (event.key === 'ArrowDown' && isOnLastBlock(editor.value)) {
        event.preventDefault();
        return ensureLastLine(editor);
      }

      return next();
    },
    renderEditor: renderEditor
  }];
}

export default LastLinePlugin;